import { addClass } from "./common";

export default class InputHint
{
  private readonly input: HTMLInputElement;
  private hintBox: HTMLElement;
  private messageElement: HTMLElement;

  constructor(input: HTMLInputElement) {
    this.input = input;
    this.createHintBox();
  }

  private createHintBox(): void {
    const div = document.createElement('div');
    const span = document.createElement('span');
    div.appendChild(span);
    this.hintBox = div;
    this.messageElement = span;
  }

  public show(message: string, className: string): void {
    this.hintBox.className = '';
    addClass(this.hintBox, 'input-hint');
    addClass(this.hintBox, 'arrow-right');
    addClass(this.hintBox, className);
    this.messageElement.innerHTML = message;
    this.hintBox.style.display = 'inline-block';
    this.updatePosition();
    this.input.parentElement.appendChild(this.hintBox);
  }

  private updatePosition() {
    const rect = this.input.parentElement.getBoundingClientRect();
    this.hintBox.style.right = `${rect.width / 2 - 35}px`;
  }

  public hide(): void {
    this.hintBox.style.display = 'none';
  }

}
